import Header from './Header';
import Testimonial from './Testimonial';

export { Header, Testimonial };



// WEBPACK FOOTER //
// ./src/components/CaseStudyPage/components/index.js